import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716d7520"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg text-center text-textPrimary" }, "Vínculos de políticas", -1))
const _hoisted_2 = { class: "text-sm text-center text-gray-600 capitalize" }
const _hoisted_3 = { class: "flex flex-1 min-h-0" }
const _hoisted_4 = { class: "w-[300px] shrink-0 bg-[#F0F0F4] border-r border-[#D8D8E2] flex flex-col" }
const _hoisted_5 = ["data-testid", "onClick"]
const _hoisted_6 = { class: "text-base leading-6 whitespace-nowrap" }
const _hoisted_7 = { class: "flex-1 flex flex-col min-w-0" }
const _hoisted_8 = { class: "flex-1 overflow-y-auto p-6" }
const _hoisted_9 = { class: "font-bold text-xl leading-6 text-[#323232] mb-6 text-left" }
const _hoisted_10 = { class: "shrink-0 px-6 pb-6" }
const _hoisted_11 = { class: "flex gap-6 w-full" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "unsaved-card" }
const _hoisted_14 = { class: "unsaved-header" }
const _hoisted_15 = { class: "unsaved-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L13 13M1 13L13 1",
    stroke: "#323232",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "unsaved-content" }
const _hoisted_19 = { class: "unsaved-message" }

import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import {
  mdiEmailOpenMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileDocumentCheckOutline
} from '@mdi/js'

import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { usePolicyLinkEditPermission } from '@/hooks/usePolicyLinkPermissions'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { AuthorizationResourcesAndSubjects } from '@/types/authorization'

import RestrictionPolicyTab from './tabs/RestrictionPolicyTab.vue'
import QualificationTransferPolicyTab from './tabs/QualificationTransferPolicyTab.vue'
import QualificationDocPolicyTab from './tabs/QualificationDocPolicyTab.vue'

const TAB_RESTRICTION_POLICY = 'Política de restrição'
const TAB_QUALIFICATION_TRANSFER = 'Qualificação para repasse'
const TAB_QUALIFICATION_DOC = 'Qualificação documental'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    resource: {}
  },
  setup(__props: any) {

const props = __props;



const modalName = EModals.RESOURCE_POLICIES_MODAL
const modalStore = useModalStore()
const { modals } = storeToRefs(modalStore)

const isSaving = ref(false)
const hasUnsavedChanges = ref(false)
const showUnsavedAlert = ref(false)
const pendingAction = ref<(() => void) | null>(null)

const restrictionPolicyTabRef = ref<InstanceType<typeof RestrictionPolicyTab> | null>(null)
const qualificationTransferTabRef = ref<InstanceType<typeof QualificationTransferPolicyTab> | null>(
  null
)
const qualificationDocTabRef = ref<InstanceType<typeof QualificationDocPolicyTab> | null>(null)

const tab = ref(1)

const { flags } = useFeatureFlags()

const tabs = computed(() => [
  TAB_RESTRICTION_POLICY,
  ...(flags.enabledPolicyModules ? [TAB_QUALIFICATION_TRANSFER, TAB_QUALIFICATION_DOC] : [])
])

const tabIcons: Record<string, string> = {
  [TAB_RESTRICTION_POLICY]: mdiFileDocumentOutline,
  [TAB_QUALIFICATION_TRANSFER]: mdiEmailOpenMultipleOutline,
  [TAB_QUALIFICATION_DOC]: mdiFileDocumentCheckOutline
}

const tabTestIds: Record<string, string> = {
  [TAB_RESTRICTION_POLICY]: 'resource-policies-tab-restriction-policy-button',
  [TAB_QUALIFICATION_TRANSFER]: 'resource-policies-tab-qualification-transfer-button',
  [TAB_QUALIFICATION_DOC]: 'resource-policies-tab-qualification-documental-button'
}

const currentTabName = computed(() => tabs.value[tab.value - 1])

const saveLabels: Record<string, string> = {
  [TAB_RESTRICTION_POLICY]: 'Salvar alterações',
  [TAB_QUALIFICATION_TRANSFER]: 'Salvar alterações',
  [TAB_QUALIFICATION_DOC]: 'Salvar alterações'
}

const currentSaveLabel = computed(() => saveLabels[currentTabName.value] || '')
const hasSaveAction = computed(() => !!currentSaveLabel.value)

const { canEditPolicyLinks } = usePolicyLinkEditPermission(() => props.resource.type)

// As tabs de qualificação (repasse e documental) não têm permissão própria —
// o gate de edição vale só para a tab de restrição
const saveDisabled = computed(() => {
  const permissionBlocked =
    currentTabName.value === TAB_RESTRICTION_POLICY && !canEditPolicyLinks.value
  return !hasUnsavedChanges.value || isSaving.value || permissionBlocked
})

const forceCloseModal = () => {
  showUnsavedAlert.value = false
  pendingAction.value = null
  modalStore.toggleModal(modalName)
  tab.value = 1
  isSaving.value = false
  hasUnsavedChanges.value = false
}

function guardedAction(action: () => void) {
  if (hasUnsavedChanges.value) {
    pendingAction.value = action
    showUnsavedAlert.value = true
  } else {
    action()
  }
}

const handleToggleModal = () => {
  guardedAction(forceCloseModal)
}

const changeTab = (index: number) => {
  if (index === tab.value) return
  guardedAction(() => {
    tab.value = index
    // A tab recém-montada não emite estado inicial — sem o reset, o estado da tab anterior vaza
    hasUnsavedChanges.value = false
    isSaving.value = false
  })
}

const confirmLeave = () => {
  showUnsavedAlert.value = false
  pendingAction.value?.()
  pendingAction.value = null
}

const cancelLeave = () => {
  showUnsavedAlert.value = false
  pendingAction.value = null
}

const handleSave = async () => {
  if (currentTabName.value === TAB_RESTRICTION_POLICY) {
    await restrictionPolicyTabRef.value?.handleSave()
  } else if (currentTabName.value === TAB_QUALIFICATION_TRANSFER) {
    await qualificationTransferTabRef.value?.handleSave()
  } else if (currentTabName.value === TAB_QUALIFICATION_DOC) {
    await qualificationDocTabRef.value?.handleSave()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      onClose: handleToggleModal,
      modalActive: _unref(modals)[_unref(modalName)],
      "max-width": "!w-[1140px] !max-w-[1140px]",
      "min-height": "90vh",
      "max-height": "90vh",
      class: "figma-custom-modal",
      "has-header-border": true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          _createElementVNode("p", _hoisted_2, " Em " + _toDisplayString(props.resource.name.toLocaleLowerCase()), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (label, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                "data-testid": tabTestIds[label],
                onClick: ($event: any) => (changeTab(index + 1)),
                class: _normalizeClass(["flex items-center gap-4 px-4 py-4 text-left transition-colors duration-200", 
            tab.value === index + 1
              ? 'bg-[#2F7F91] text-white font-bold'
              : 'text-[#16161D] hover:bg-[#E8E8EE]'
          ])
              }, [
                _createVNode(_component_v_icon, {
                  size: "24",
                  icon: tabIcons[label],
                  color: tab.value === index + 1 ? 'white' : '#16161D'
                }, null, 8, ["icon", "color"]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(label), 1)
              ], 10, _hoisted_5))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(currentTabName.value), 1),
              (tabs.value[tab.value - 1] === TAB_RESTRICTION_POLICY)
                ? (_openBlock(), _createBlock(RestrictionPolicyTab, {
                    key: 0,
                    ref_key: "restrictionPolicyTabRef",
                    ref: restrictionPolicyTabRef,
                    "resource-type": props.resource.type,
                    "resource-id": props.resource.id,
                    "company-id": props.resource.companyId,
                    "onUpdate:isSaving": _cache[0] || (_cache[0] = ($event: any) => (isSaving.value = $event)),
                    "onUpdate:hasUnsavedChanges": _cache[1] || (_cache[1] = ($event: any) => (hasUnsavedChanges.value = $event))
                  }, null, 8, ["resource-type", "resource-id", "company-id"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_QUALIFICATION_TRANSFER)
                ? (_openBlock(), _createBlock(QualificationTransferPolicyTab, {
                    key: 1,
                    ref_key: "qualificationTransferTabRef",
                    ref: qualificationTransferTabRef,
                    "resource-type": props.resource.type,
                    "resource-id": props.resource.id,
                    "company-id": props.resource.companyId,
                    "onUpdate:isSaving": _cache[2] || (_cache[2] = ($event: any) => (isSaving.value = $event)),
                    "onUpdate:hasUnsavedChanges": _cache[3] || (_cache[3] = ($event: any) => (hasUnsavedChanges.value = $event))
                  }, null, 8, ["resource-type", "resource-id", "company-id"]))
                : _createCommentVNode("", true),
              (tabs.value[tab.value - 1] === TAB_QUALIFICATION_DOC)
                ? (_openBlock(), _createBlock(QualificationDocPolicyTab, {
                    key: 2,
                    ref_key: "qualificationDocTabRef",
                    ref: qualificationDocTabRef,
                    "resource-type": props.resource.type,
                    "resource-id": props.resource.id,
                    "company-id": props.resource.companyId,
                    "onUpdate:isSaving": _cache[4] || (_cache[4] = ($event: any) => (isSaving.value = $event)),
                    "onUpdate:hasUnsavedChanges": _cache[5] || (_cache[5] = ($event: any) => (hasUnsavedChanges.value = $event))
                  }, null, 8, ["resource-type", "resource-id", "company-id"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(OutlinedButton, {
                  "data-testid": "resource-policies-close-button",
                  class: "flex-1",
                  text: "Fechar",
                  height: "48px",
                  onClick: handleToggleModal
                }),
                (hasSaveAction.value)
                  ? (_openBlock(), _createBlock(FilledButton, {
                      key: 0,
                      "data-testid": "resource-policies-save-button",
                      class: "flex-1",
                      disabled: saveDisabled.value,
                      loading: isSaving.value,
                      color: "primary30",
                      text: currentSaveLabel.value,
                      height: "48px",
                      onClick: handleSave
                    }, null, 8, ["disabled", "loading", "text"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    (showUnsavedAlert.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "unsaved-overlay",
          onClick: _withModifiers(cancelLeave, ["self"])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, "Sair da aba " + _toDisplayString(currentTabName.value) + "?", 1),
              _createElementVNode("button", {
                class: "unsaved-close",
                onClick: cancelLeave
              }, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", _hoisted_19, " Você tem edições não salvas na aba " + _toDisplayString(currentTabName.value?.toLowerCase()) + ". Se sair sem salvar, as alterações serão perdidas ", 1),
              _createElementVNode("div", { class: "unsaved-actions" }, [
                _createElementVNode("button", {
                  class: "unsaved-btn-voltar",
                  onClick: cancelLeave
                }, "Voltar"),
                _createElementVNode("button", {
                  class: "unsaved-btn-sair",
                  onClick: confirmLeave
                }, "Sair")
              ])
            ])
          ])
        ], 8, _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}
}

})